import React, { createContext, useState, useCallback } from 'react';

export const TransactionContext = createContext();

export const TransactionProvider = ({ children }) => {
  const [shouldRefresh, setShouldRefresh] = useState(0);

  const refreshTransactions = useCallback(() => {
    setShouldRefresh(prev => prev + 1);
  }, []);

  return (
    <TransactionContext.Provider value={{ shouldRefresh, refreshTransactions }}>
      {children}
    </TransactionContext.Provider>
  );
}; 